import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { InfectedDataOverTime } from '../models/InfectedDataOverTime';
import { Provider } from '../models/Provider';

/**
 * no description
 */
export class GetInfectedDataOverTimeApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Get the infected resources size history
   * @param projectId The project ID
   * @param days Number of days to fetch data for
   * @param prod Filter data on production resources only, default is false
   * @param providers Filter data on specified cloud providers only, default is all
   */
  public async getInfectedDataOverTime(projectId: string, days: number, prod?: boolean, providers?: Array<Provider>, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("GetInfectedDataOverTimeApi", "getInfectedDataOverTime", "projectId");
    }


    // verify required parameter 'days' is not null or undefined
    if (days === null || days === undefined) {
      throw new RequiredError("GetInfectedDataOverTimeApi", "getInfectedDataOverTime", "days");
    }




    // Path Params
    const localVarPath = '/projects/{projectId}/dashboard/home/infected-data-over-time'
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.GET, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

    // Query Params
    if (prod !== undefined) {
      requestContext.setQueryParam("prod", ObjectSerializer.serialize(prod, "boolean", ""));
    }

    // Query Params
    if (providers !== undefined) {
      requestContext.setQueryParam("providers", ObjectSerializer.serialize(providers, "Array<Provider>", ""));
    }

    // Query Params
    if (days !== undefined) {
      requestContext.setQueryParam("days", ObjectSerializer.serialize(days, "number", ""));
    }


    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class GetInfectedDataOverTimeApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to getInfectedDataOverTime
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async getInfectedDataOverTimeWithHttpInfo(response: ResponseContext): Promise<HttpInfo<InfectedDataOverTime >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: InfectedDataOverTime = ObjectSerializer.deserialize(
        await response.body.json(),
        "InfectedDataOverTime", ""
      ) as InfectedDataOverTime;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: InfectedDataOverTime = await response.body.json() as InfectedDataOverTime;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
